import { Injectable } from "@angular/core";
import { ApplicationMessageResponse, ASWPClient } from "src/domain/client";
import Toast, { TOAST_TYPE } from "src/domain/extentions/toast";
import TopBannerMessage from "src/domain/extentions/top-banner-message";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  toasts: Toast[] = [];
  topBannerMessages: TopBannerMessage[] = [];
  applicationMessages: ApplicationMessageResponse[] = [];

  constructor() {}

  createToast(text: string, type: TOAST_TYPE, timeout = 10): void {
    const sameToast = this.toasts.find((t) => t.text === text);

    if (!sameToast) {
      this.addToast(text, type, timeout);
    } else {
      clearTimeout(sameToast.timeout);
      sameToast.timeout = this.setTimeout(sameToast.toastId, timeout);
    }
  }

  deleteToast(toastId: string): void {
    const index = this.toasts.findIndex((t) => t.toastId === toastId);
    if (index > -1) {
      this.toasts.splice(index, 1);
    }
  }

  createTopBannerMessage(
    title: string,
    text: string,
    backdrop: boolean,
    closeCallback?: () => void,
  ): void {
    const existingTopBannerMessage = this.topBannerMessages.find(
      (_) => _.title === title && _.text === text,
    );

    if (!existingTopBannerMessage) {
      const topBannerMessage = new TopBannerMessage({
        topBannerMessageId: this.generateId(),
        title,
        text,
        backdrop,
        closeCallback,
      });

      this.topBannerMessages.push(topBannerMessage);
    }
  }

  deleteTopBannerMessage(topBannerMessageId: string): void {
    const index = this.topBannerMessages.findIndex(
      (t) => t.topBannerMessageId === topBannerMessageId,
    );
    if (index > -1) {
      const topBannerMessage = this.topBannerMessages[index];

      if (topBannerMessage.closeCallback) {
        topBannerMessage.closeCallback();
      }

      this.topBannerMessages.splice(index, 1);
    }
  }

  getApplicationMessages(): void {
    new ASWPClient()
      .getActiveApplicationMessagesByApplicationType()
      .then((applicationMessages) => {
        this.applicationMessages = applicationMessages;
      })
      .catch(() => {
        // fail silently
      });
  }

  closeApplicationMessage(applicationMessageId: number): void {
    const index = this.applicationMessages.findIndex(
      (_) => _.applicationMessageId === applicationMessageId,
    );
    if (index > -1) {
      this.applicationMessages.splice(index, 1);
    }
  }
  //////////

  private addToast(text: string, type: TOAST_TYPE, timeout = 10): void {
    const toastId = this.generateId();

    const toast = new Toast({
      toastId,
      text,
      type,
    });

    toast.timeout = this.setTimeout(toastId, timeout);

    this.toasts.push(toast);
  }

  private setTimeout(toastId: string, timeout?: number): number {
    return window.setTimeout(
      () => this.deleteToast(toastId),
      timeout ? timeout * 1000 : 10000,
    );
  }

  private generateId(): string {
    return `${Math.floor(
      Math.random() * 1000000,
    ).toString()}_${Date.now().toString()}`;
  }
}
